import React from 'react';
import { BarChart2Icon, PlusIcon } from 'lucide-react';
import { familyMembers } from '../../data/carte';
interface FamilySectionProps {
  selectedId: string;
  onSelect: (id: string) => void;
}
export function FamilySection({
  selectedId,
  onSelect
}: FamilySectionProps) {
  return <section id="famille" aria-labelledby="famille-titre" className="mt-8 scroll-mt-28 rounded-3xl bg-slate-50 p-7 sm:p-8" data-id="element-783" data-mp="cypv02j0iuya">
      <h2 id="famille-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-784" data-mp="3bhepchji0ayj">
        Ma famille
      </h2>

      <ul className="mt-6 grid grid-cols-4 gap-x-4 gap-y-6" data-id="element-785" data-mp="3gg7yjxrr5fsw">
        {familyMembers.map(member => {
        const active = member.id === selectedId;
        return <li key={member.id} className="text-center" data-id="element-786" data-mp="3q6ku0l13utdt">
              <div className="inline-block" data-id="element-787" data-mp="2sq5d40icf839">
                <button type="button" onClick={() => onSelect(member.id)} aria-pressed={active} aria-label={`Afficher la carte de ${member.firstName}`} className="rounded-full transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-788" data-mp="2spcdrklprkv5">
                  <img src={member.photo} alt={member.firstName} className={`h-[76px] w-[76px] rounded-full object-cover ring-4 ${active ? 'ring-ville-indigo' : 'ring-white'}`} data-id="element-789" data-mp="14nzarib6i7fn" />
                </button>
              </div>
              <p className="mt-2 text-[15px] font-bold leading-tight text-ville-navy" data-id="element-790" data-mp="qoznadzejyl2">{member.firstName}</p>
            </li>;
      })}

        <li data-id="element-791" data-mp="lrhovhj0h1rb">
          <button type="button" className="group flex w-full flex-col items-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-792" data-mp="2l1z9ipyafr1b">
            <span className="grid h-[76px] w-[76px] place-items-center rounded-full bg-white text-slate-400 ring-1 ring-slate-200 transition-colors duration-150 ease-ville group-hover:text-ville-indigo group-hover:ring-ville-indigo" data-id="element-793" data-mp="ee8ngqmi1hpa">
              <PlusIcon className="h-7 w-7" aria-hidden="true" data-id="element-794" data-mp="4h3ykj19r84s" />
            </span>
            <span className="mt-2 text-[15px] font-bold leading-tight text-ville-indigo" data-id="element-795" data-mp="9e48x655ix1p">Ajouter</span>
          </button>
        </li>
      </ul>

      <div className="mt-6 flex items-start gap-3 rounded-2xl bg-ville-indigo-soft px-5 py-4" data-id="element-796" data-mp="x2dm5joauch8">
        <BarChart2Icon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-797" data-mp="122ru71pwhmf9" />
        <div className="text-[15px] leading-relaxed text-ville-indigo" data-id="element-798" data-mp="o3idm0xs8qar">
          <p className="font-semibold" data-id="element-799" data-mp="s42cb8y081z0">Activités familiales : 3 cette semaine</p>
          <p data-id="element-800" data-mp="38trbxz3sb8jl">Dernier accès : Emma au Complexe aquatique</p>
        </div>
      </div>
    </section>;
}